import type { FC, HTMLAttributes } from 'react'
import styled from 'styled-components'

export default styled.div`
  border-radius: 16px;
  background-color: ${({ theme }) => theme.color.neutral.color11};
  padding: 16px 24px;
` as FC<HTMLAttributes<HTMLDivElement>>
